import React from "react";
import { enviroment } from "../../../../enviroment";
import { Button } from "../../../components/buttons/Button";
import { ContentHeader } from "../../../components/structure/ContentHeader";


const AUTH_URL = enviroment.authUrl;

export function SignedOutScreen() {
    function login() {
        window.location.href = AUTH_URL + "/auth/login?redirectUri=" + encodeURIComponent(window.location.origin);
    }

    return <div className={"flex flex-col items-center mx-auto mt-[120px]"}>
        <ContentHeader className={"text-l mb-16"}>
            Du er logget af administrationspotalen for Digital Lægeattest
        </ContentHeader>
        <p
            className={
                "text-xn break-normal max-w-[650px] mb-32 text-center"
            }
        >
            Hvis andre har adgang til denne computer, anbefaler vi, at du lukker
            <br />
            browseren. Vær opmærksom på at lukke alle åbne vinduer.
        </p>
        <Button onClick={login} size={"m"} iconRight>
            Gå til log ind
        </Button>
    </div>;

}
